import React, { useEffect, useState } from "react";
import { EditorData, Picking } from "../../../utils/editorUtils";
import { FormattedMessage } from "react-intl";
import { ReactComponent as AddIcon } from "./../../../images/editor-icons/plus.svg";
import { useEditState } from "../EditContext";
import Tooltip from "../BaseComponents/Tooltip";
import { useAppState } from "../../../AppContext";
import { PanoScenario } from "../../../types";
import ActionList from "../../../shared/components/ActionList";
import { StyledNavigationMobile } from "../../Navigation/NavigationMobileStyles";
import Action from "../../../shared/components/Action";

interface PanoAddButtonsProps {
  setPicking: React.Dispatch<React.SetStateAction<Picking>>;
  scenario: PanoScenario;
}

const PanoAddButtons: React.FC<PanoAddButtonsProps> = ({ setPicking, scenario }) => {
  const { data, target } = useEditState();
  const [editorData, setEditorData] = useState<EditorData<"pano">>(data as EditorData<"pano">);
  const { state } = useAppState();
  useEffect(() => {
    setEditorData(data as EditorData<"pano">);
  }, [data]);

  const panoDisabled = !(
    state.panos.some(pano => pano.id !== target && pano.scenarios.some(s => s.id === scenario.id))
  );
  const poiDisabled = !(
    state.pois.some(poi => poi.scenarios.some(s => s === scenario.id))
  );

  return (
    <StyledNavigationMobile style={{position: "absolute", top: "calc(-100vh + 16px)", left: "16px"}}>
      <ActionList>
        <Tooltip
          message={
            <FormattedMessage
              id="editor.pano.link.add_link.no_pano_locations"
              defaultMessage="All available panoramas have already been placed."
              description="Tooltip for disabled panorama button when no panoramas are available"
            />
          }
          disabled={!panoDisabled}
        >
          <Action
            icon={<AddIcon />}
            onClick={() => panoDisabled || setPicking(Picking.Pano)}
            disabled={panoDisabled}
          >
            <FormattedMessage
              id="editor.pano.link.add_pano"
              defaultMessage="Add panorama"
              description="Text for add panorama link button"
            />
          </Action>
        </Tooltip>
        <Tooltip
          message={
            <FormattedMessage
              id="editor.pano.link.add_link.no_poi_locations"
              defaultMessage="All available pois have already been placed."
              description="Tooltip for disabled POI button when no pois are available"
            />
          }
          disabled={!poiDisabled}
        >
          <Action
            icon={<AddIcon />}
            onClick={() => poiDisabled || setPicking(Picking.Poi)}
            disabled={poiDisabled}
          >
            <FormattedMessage
              id="editor.pano.link.add_poi"
              defaultMessage="Add POI"
              description="Text for add poi link button"
            />
          </Action>
        </Tooltip>
      </ActionList>
    </StyledNavigationMobile>
  );
};

export default PanoAddButtons;
